// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   Modal,
//   Form,
//   Table,
//   Spinner,
// } from 'react-bootstrap';
// import { FaSearch, FaTrash } from 'react-icons/fa';
// import { Pencil } from 'lucide-react';
// import Swal from 'sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';

// const API_URL = 'https://kaasbackend.vetrinahealthcare.com/master/divisions/';

// const DivisionManager = () => {
//   const [divisions, setDivisions] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [divisionInput, setDivisionInput] = useState('');
//   const [editItem, setEditItem] = useState(null);
//   const [isPageLoading, setIsPageLoading] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isDeletingId, setIsDeletingId] = useState(null);

//   const token = localStorage.getItem('jwttoken');

//   useEffect(() => {
//     fetchDivisions();
//   }, []);

//   const fetchDivisions = async () => {
//     setIsPageLoading(true);
//     try {
//       const res = await fetch(API_URL, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!res.ok) {
//         const error = await res.json();
//         Swal.fire('Error', error.detail || 'Failed to fetch divisions', 'error');
//         return;
//       }

//       const data = await res.json();
//       setDivisions(data);
//     } catch (err) {
//       console.error(err);
//       Swal.fire('Error', 'Network error', 'error');
//     } finally {
//       setIsPageLoading(false);
//     }
//   };

//   const handleShowModal = () => {
//     setDivisionInput('');
//     setEditItem(null);
//     setShowModal(true);
//   };

//   const handleClose = () => {
//     setDivisionInput('');
//     setEditItem(null);
//     setShowModal(false);
//   };

//   const handleAddOrUpdate = async () => {
//     const trimmed = divisionInput.trim();
//     if (!trimmed) return;

//     setIsLoading(true);

//     if (editItem) {
//       // PATCH
//       try {
//         const res = await fetch(`${API_URL}${editItem.id}/`, {
//           method: 'PATCH',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to update', 'error');
//           return;
//         }

//         Swal.fire('Updated!', 'Division updated successfully.', 'success');
//         fetchDivisions();
//         handleClose();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsLoading(false);
//       }
//     } else {
//       // POST
//       try {
//         const res = await fetch(API_URL, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to add division', 'error');
//           return;
//         }

//         Swal.fire('Added!', 'Division added successfully.', 'success');
//         fetchDivisions();
//         handleClose();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   const handleEdit = (division) => {
//     setDivisionInput(division.name);
//     setEditItem(division);
//     setShowModal(true);
//   };

//   const handleDelete = async (division) => {
//     const confirm = await Swal.fire({
//       title: 'Are you sure?',
//       text: `Delete "${division.name}"?`,
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!',
//     });

//     if (confirm.isConfirmed) {
//       setIsDeletingId(division.id);

//       try {
//         const res = await fetch(`${API_URL}${division.id}/`, {
//           method: 'DELETE',
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to delete', 'error');
//           return;
//         }

//         Swal.fire('Deleted!', 'Division deleted successfully.', 'success');
//         fetchDivisions();
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsDeletingId(null);
//       }
//     }
//   };

//   const filteredDivisions = divisions.filter((d) =>
//     d.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="p-4">
//       <h4 className="mb-3 text-center">Manage Divisions</h4>

//       <div className="d-flex justify-content-between mb-3">
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             position: 'relative',
//             width: '300px',
//           }}
//         >
//           <FaSearch
//             style={{
//               position: 'absolute',
//               left: '10px',
//               color: '#888',
//             }}
//           />
//           <input
//             type="text"
//             placeholder="Search Division..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={{
//               padding: '8px 10px 8px 35px',
//               border: '1px solid #ddd',
//               borderRadius: '5px',
//               width: '100%',
//             }}
//           />
//         </div>

//         <Button
//           onClick={handleShowModal}
//           style={{
//             background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//             color: 'white',
//             border: 'none',
//           }}
//         >
//           + Add Division
//         </Button>
//       </div>

//       {isPageLoading ? (
//         <div className="text-center my-5">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <Table striped hover responsive>
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Division</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredDivisions.length > 0 ? (
//               filteredDivisions.map((d) => (
//                 <tr key={d.id}>
//                   <td>{d.id}</td>
//                   <td>{d.name}</td>
//                   <td>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       className="me-2"
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#7366ff',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleEdit(d)}
//                     >
//                       <Pencil size={20} />
//                     </Button>
//                     <Button
//                       variant="white"
//                       size="sm"
//                       className="me-2"
//                       style={{
//                         background: 'none',
//                         border: 'none',
//                         color: '#ff5370',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleDelete(d)}
//                       disabled={isDeletingId === d.id}
//                     >
//                       {isDeletingId === d.id ? (
//                         <Spinner size="sm" animation="border" />
//                       ) : (
//                         <FaTrash size={20} />
//                       )}
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="3" className="text-center text-muted">
//                   No divisions found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       <Modal show={showModal} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{editItem ? 'Edit' : 'Add'} Division</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form.Control
//             type="text"
//             placeholder="Enter division name"
//             value={divisionInput}
//             onChange={(e) => setDivisionInput(e.target.value)}
//           />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             style={{
//               background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//               color: 'white',
//               border: 'none',
//             }}
//             onClick={handleAddOrUpdate}
//             disabled={isLoading}
//           >
//             {isLoading ? (
//               <Spinner size="sm" animation="border" />
//             ) : (
//               editItem ? 'Update Division' : 'Add Division'
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default DivisionManager;


import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Table,
  Spinner,
  Pagination,
} from 'react-bootstrap';
import { FaSearch, FaTrash } from 'react-icons/fa';
import { Pencil } from 'lucide-react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const API_URL = 'https://kaasbackend.vetrinahealthcare.com/master/divisions/';

const DivisionManager = () => {
  const [divisions, setDivisions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [divisionInput, setDivisionInput] = useState('');
  const [editItem, setEditItem] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeletingId, setIsDeletingId] = useState(null);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const token = localStorage.getItem('jwttoken');

  useEffect(() => {
    fetchDivisions();
  }, []);

  const fetchDivisions = async () => {
    setIsPageLoading(true);
    try {
      const res = await fetch(API_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        const error = await res.json();
        Swal.fire('Error', error.detail || 'Failed to fetch divisions', 'error');
        return;
      }

      const data = await res.json();
      setDivisions(data);
      setCurrentPage(1); // Reset to first page when data changes
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Network error', 'error');
    } finally {
      setIsPageLoading(false);
    }
  };

  // Filter divisions based on search term
  const filteredDivisions = divisions.filter((d) =>
    d.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDivisions.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredDivisions.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleShowModal = () => {
    setDivisionInput('');
    setEditItem(null);
    setShowModal(true);
  };

  const handleClose = () => {
    setDivisionInput('');
    setEditItem(null);
    setShowModal(false);
  };

  const handleAddOrUpdate = async () => {
    const trimmed = divisionInput.trim();
    if (!trimmed) return;

    setIsLoading(true);

    if (editItem) {
      // PATCH
      try {
        const res = await fetch(`${API_URL}${editItem.id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to update', 'error');
          return;
        }

        Swal.fire('Updated!', 'Division updated successfully.', 'success');
        fetchDivisions();
        handleClose();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsLoading(false);
      }
    } else {
      // POST
      try {
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to add division', 'error');
          return;
        }

        Swal.fire('Added!', 'Division added successfully.', 'success');
        fetchDivisions();
        handleClose();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleEdit = (division) => {
    setDivisionInput(division.name);
    setEditItem(division);
    setShowModal(true);
  };

  const handleDelete = async (division) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Delete "${division.name}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirm.isConfirmed) {
      setIsDeletingId(division.id);

      try {
        const res = await fetch(`${API_URL}${division.id}/`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to delete', 'error');
          return;
        }

        Swal.fire('Deleted!', 'Division deleted successfully.', 'success');
        fetchDivisions();
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsDeletingId(null);
      }
    }
  };

  return (
    <div className="p-4">
      <h4 className="mb-3 text-center">Manage Divisions</h4>

      <div className="d-flex justify-content-between mb-3">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            width: '300px',
          }}
        >
          <FaSearch
            style={{
              position: 'absolute',
              left: '10px',
              color: '#888',
            }}
          />
          <input
            type="text"
            placeholder="Search Division..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '8px 10px 8px 35px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              width: '100%',
            }}
          />
        </div>

        <Button
          onClick={handleShowModal}
          style={{
            background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
            color: 'white',
            border: 'none',
          }}
        >
          + Add Division
        </Button>
      </div>

      {isPageLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Division</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((d, index) => (
                  <tr key={d.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{d.name}</td>
                    <td>
                      <Button
                        variant="white"
                        size="sm"
                        className="me-2"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#7366ff',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleEdit(d)}
                      >
                        <Pencil size={20} />
                      </Button>
                      <Button
                        variant="white"
                        size="sm"
                        className="me-2"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#ff5370',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleDelete(d)}
                        disabled={isDeletingId === d.id}
                      >
                        {isDeletingId === d.id ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          <FaTrash size={20} />
                        )}
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center text-muted">
                    No divisions found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          {filteredDivisions.length > itemsPerPage && (
            <div className="d-flex justify-content-center mt-3">
              <Pagination>
                <Pagination.First 
                  onClick={() => paginate(1)} 
                  disabled={currentPage === 1} 
                />
                <Pagination.Prev 
                  onClick={() => paginate(currentPage - 1)} 
                  disabled={currentPage === 1} 
                />
                
                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => paginate(index + 1)}
                    style={{
                      backgroundColor: index + 1 === currentPage ? 'orange' : '',
                      borderColor: index + 1 === currentPage ? 'orange' : '',
                      color: index + 1 === currentPage ? 'white' : '',
                    }}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                
                <Pagination.Next 
                  onClick={() => paginate(currentPage + 1)} 
                  disabled={currentPage === totalPages} 
                />
                <Pagination.Last 
                  onClick={() => paginate(totalPages)} 
                  disabled={currentPage === totalPages} 
                />
              </Pagination>
            </div>
          )}
        </>
      )}

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editItem ? 'Edit' : 'Add'} Division</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            placeholder="Enter division name"
            value={divisionInput}
            onChange={(e) => setDivisionInput(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            style={{
              background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
              color: 'white',
              border: 'none',
            }}
            onClick={handleAddOrUpdate}
            disabled={isLoading}
          >
            {isLoading ? (
              <Spinner size="sm" animation="border" />
            ) : (
              editItem ? 'Update Division' : 'Add Division'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DivisionManager;